<div #channelPlayer class="container">
  <app-channel-player class="channel-player"></app-channel-player>
  <ng-container *ngIf="isChannelPage && channel">
    <app-tracks-menu-v3 [channel]="channel" [visible]="trackMenuVisible" (hide)="hideTrackMenu()"></app-tracks-menu-v3>
  </ng-container>
  <div class="overlay" *ngIf="showProgressBar && channel">
    <app-channel-progress class="progress" [channel]="channel"></app-channel-progress>
  </div>
</div>
